<div class="modal-header">
  <h5 class="modal-title">Transaction Details</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body">
  @if (transactionData) {
    <div class="container-fluid">
      <div class="row pt-2">
        <div class="col-md-3">
          Merchant Name
        </div>
        <div class="col-md-9">
          : {{ transactionData?.merchantName }}
        </div>
        <div class="col-md-3">
          Customer Name
        </div>
        <div class="col-md-9">
          : {{ transactionData?.customerId?.name }}
        </div>
        <div class="col-md-3">
          Email Id
        </div>
        <div class="col-md-9">
          : {{ transactionData?.customerId?.emailId }}
        </div>
        <div class="col-md-3">
          Origination Country
        </div>
        <div class="col-md-9">
          : {{ transactionData?.customerId?.country?.displayName }}
        </div>
        <div class="col-md-3">
          Recipient Country
        </div>
        <div class="col-md-9">
          : {{ transactionData?.customerId?.destinationCountry?.displayName }}
        </div>
        <div class="col-md-3">
          Transaction Amount
        </div>
        <div class="col-md-9">
          : {{ transactionAmount }}
        </div>
        <div class="col-md-3">
          Location
        </div>
        <div class="col-md-9">
          : {{ getLatLongFromLocation(transactionData?.location) }}
        </div>
        <div class="col-md-3">
          Status
        </div>
        <div class="col-md-9">
          : {{transactionData?.status }}
        </div>
        <div class="col-md-3">
          Created At
        </div>
        <div class="col-md-9">
          : {{ dateFormat(transactionData?.createdAt) }}
        </div>
      </div>
    </div>
  }